<template>
  <div>
    <div v-if="!!section">
      <div class="text-h6 text-center mt-2 mb-2">場次資訊</div>

      <v-row>
        <v-col>
          <v-text-field
            label="日期"
            :value="section.日期"
            dense
            outlined
            disabled
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            label="地點"
            :value="section.地點"
            dense
            outlined
            disabled
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="text-h6 text-center mt-6 mb-2">掛號資訊</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col class="ma-0 pb-0">
            <v-text-field
              label="姓名"
              v-model="person.姓名"
              dense
              outlined
              :rules="[(v) => !!v || '此為必填欄位']"
            ></v-text-field>
          </v-col>
          <v-col class="ma-0 pb-0">
            <v-text-field
              label="手機號碼"
              v-model="person.電話"
              dense
              outlined
              :rules="[
                (v) => !!v || `手機號碼為必填項目`,
                (v) => /^09\d{8}$/.test(v) || `手機格式 10 碼`,
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pb-0 pt-0">
            <v-text-field
              label="身分證字號"
              v-model="person.身分證字號"
              dense
              outlined
              :rules="[
                (v) => !!v || `此為必填欄位`,
                (v) =>
                  /^[A-Za-z0-9]{10}$/.test(v) ||
                  `身分證字號格式錯誤，含英文共 10 碼`,
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pb-0 pt-0">
            <v-text-field
              label="出生年月日"
              v-model="person.出生年月日"
              dense
              outlined
              hint="例如 35 年 04 月 11 日，請輸入 350411"
              persistent-hint
              :rules="[
                (v) => !!v || `出生年月日為必填項目`,
                (v) =>
                  /^\d?\d{6}$/.test(v) ||
                  `例如 35 年 04 月 11 日，請輸入 350411`,
              ]"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="ma-0 pb-0 pt-0">
            <v-select
              label="行政區"
              :items="行政區"
              v-model="person.行政區"
              dense
              outlined
              :rules="[(v) => !!v || '此為必填欄位']"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pt-0">
            <v-text-field
              label="地址"
              v-model="person.地址"
              dense
              outlined
              :rules="[(v) => !!v || '此為必填欄位']"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-btn block large color="#0f4c81" dark @click="submit"> 確認 </v-btn>
    </div>
  </div>
</template>

<script>
import { 行政區 } from "@/libs/const.js";
export default {
  name: "station",
  data: () => ({
    valid: false,
    行政區,
    section: {},
    id: null,
    person: {
      // 姓名: "王曉明",
      // 電話: "0921123456",
      // 身分證字號: "A111111111",
      // 出生年月日: "720101",
      // 行政區: "北區",
      // 地址: "dddddd",
    },
  }),
  computed: {},
  async created() {
    let id = this.$route.params.id;
    if (id && /^[0-9a-fA-F]{24}$/.test(id)) {
      this.section = (await this.axios.get(`/section/${id}`)).data;
      this.$forceUpdate();
    }
  },
  methods: {
    async submit() {
      this.valid = this.$refs.form.validate();
      try {
        let result = await this.axios.post("/apply", {
          ...this.person,
          日期: this.section.日期,
          地點: this.section.地點,
        });
        this.$toast.success("已完成掛號，請回到報到台報到！");
        setTimeout(() => {
          this.$router.push("/");
        }, 10000);
      } catch (error) {
        this.$toast.error("掛號失敗，請聯繫現場人員處理！");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-alert {
  position: fixed;
  top: 50%;
  width: 96%;
  left: 2%;
}
</style>
